// import pjson from '@../package.json'

const THROW_DEFAULT_MESSAGE = 'An error has occurred'

export default class ThrowManager {
    constructor(UNIQUE_LIBRARY_ID) {
        this.uniqueLibraryId = UNIQUE_LIBRARY_ID || '___'
    }

    throw(messageId, message) {
        let _messageId = (messageId && typeof messageId === 'string') ? messageId : '___'
        let _message = (message && typeof message === 'string') ? message : THROW_DEFAULT_MESSAGE
        // console.error(`${pjson[name]}${pjson[version]}`, `${this.uniqueLibraryId}_${messageId}`, `${_message}`)
        throw (`${this.uniqueLibraryId}_${_messageId}: ${_message}`)
    }
}